import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Calendar, Clock } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EmployeeAttendance = () => {
  const { getAuthHeader } = useAuth();
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentMonth = new Date().toISOString().substring(0, 7);

  useEffect(() => { fetchAttendance(); }, []);

  const fetchAttendance = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/employee/attendance?month=${currentMonth}`, { headers: getAuthHeader() });
      setAttendance(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const colors = {
      present: 'bg-green-100 text-green-800',
      absent: 'bg-red-100 text-red-800',
      half_day: 'bg-yellow-100 text-yellow-800',
      leave: 'bg-blue-100 text-blue-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const stats = {
    present: attendance.filter(a => a.status === 'present').length,
    absent: attendance.filter(a => a.status === 'absent').length,
    leaves: attendance.filter(a => a.status === 'leave').length
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Attendance</h2>

      <div className="grid md:grid-cols-3 gap-4">
        <Card><CardHeader className="pb-3"><CardTitle className="text-sm font-medium text-gray-600">Present Days</CardTitle></CardHeader><CardContent><div className="text-3xl font-bold text-green-600">{stats.present}</div></CardContent></Card>
        <Card><CardHeader className="pb-3"><CardTitle className="text-sm font-medium text-gray-600">Absent Days</CardTitle></CardHeader><CardContent><div className="text-3xl font-bold text-red-600">{stats.absent}</div></CardContent></Card>
        <Card><CardHeader className="pb-3"><CardTitle className="text-sm font-medium text-gray-600">Leaves Taken</CardTitle></CardHeader><CardContent><div className="text-3xl font-bold text-blue-600">{stats.leaves}</div></CardContent></Card>
      </div>

      <Card>
        <CardHeader><CardTitle>Attendance History - {currentMonth}</CardTitle></CardHeader>
        <CardContent>
          {attendance.length > 0 ? (
            <div className="space-y-2">
              {attendance.map((record) => (
                <div key={record.id} className="flex items-center justify-between p-3 border rounded-lg">
                  <div className="flex items-center gap-3">
                    <Calendar size={16} className="text-gray-500" />
                    <span className="font-medium">{new Date(record.date).toLocaleDateString()}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    {record.check_in && <span className="text-sm text-gray-600"><Clock size={14} className="inline mr-1" />{record.check_in}</span>}
                    {record.check_out && <span className="text-sm text-gray-600">- {record.check_out}</span>}
                    <Badge className={getStatusBadge(record.status)}>{record.status.replace('_', ' ').toUpperCase()}</Badge>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-center py-8">No attendance records for this month</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default EmployeeAttendance;
